const trimZeros = (s) => s.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");

export const formatCompactUsd = (n, digits = 2) => {
  if (n == null || Number.isNaN(n)) return "—";
  const abs = Math.abs(n);
  const units = [[1e9, "B"], [1e6, "M"], [1e3, "K"]];
  for (const [v, s] of units) {
    if (abs >= v) return `$${trimZeros((n / v).toFixed(digits))}${s}`;
  }
  return `$${trimZeros(n.toFixed(digits))}`;
};

export const formatPrice = (p) => {
  if (p == null || Number.isNaN(p)) return "—";
  if (p >= 1) return `$${p.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  if (p === 0) return "$0.00";
  const digits = Math.min(10, Math.max(2, -Math.floor(Math.log10(p)) + 2));
  return `$${p.toFixed(digits)}`;
};

export const formatPercent = (v) => {
  if (v == null || Number.isNaN(v)) return "—";
  return `${v > 0 ? "+" : ""}${v.toFixed(2)}%`;
};

export const formatProgress = (p) => {
  const pct = Math.min(Math.max(p ?? 0, 0), 1) * 100;
  return `${Number.isInteger(pct) ? pct : pct.toFixed(1)}%`;
};

export const formatInt = (n) => (n == null ? "—" : Math.round(n).toLocaleString("en-US"));

export const truncateAddress = (a, head = 6, tail = 6) =>
  a && a.length > head + tail + 3 ? `${a.slice(0, head)}…${a.slice(-tail)}` : a;
